"use strict";

(function () {
  'use strict';

  function accountVerifyCtrl($state, LoginService, UtilsService, LRNotification) {
    var vm = this;
    vm.errMsg = '';
    vm.successMessage = '';

    if ($state.params.errMsg) {
      switch ($state.params.errMsg) {
        case 'token_expired':
          vm.errMsg = 'Verification token is expired. Please enter your email below to resend a verification email.';
          break;

        case 'user_error':
          vm.errMsg = 'Error with email verification. Please enter your email below to resend a verification email.';
          break;

        case 'server_error':
          vm.errMsg = 'Error with email verification. Please wait a few minutes and try again.';
          break;

        default:
          vm.errMsg = 'Error with email verification. Please try again.';
      }
    }

    if ($state.params.successMsg) {
      switch ($state.params.successMsg) {
        case 'account_verified':
          vm.successMessage = 'Thank you for verifying your account. Please use the link below to proceed to the login page.';
          break;
      }
    }

    vm.resendVerification = function (form, email) {
      vm.errMsg = '';
      vm.successMessage = '';

      if (!UtilsService.Form.isValid(form)) {
        UtilsService.Form.validateForm(form);
      } else {
        vm.loading = 'verification';
        LoginService.resendVerification(email).then(function (response) {
          vm.successMessage = 'A verification email has been sent to you. Please view your email and click the link provided in it.';
          vm.loading = false;
        }, function (errorMessage) {
          switch (errorMessage) {
            case 'server_error':
              vm.errMsg = 'There was an issue with ';
              break;

            case 'no_user':
              vm.errMsg = 'No account was found with the email address provided.';
              break;

            case 'user_verified':
              vm.errMsg = 'Account has already been verified, please proceed to login.';
              break;
          }

          LRNotification.error(vm.errMsg, 3500);
          vm.loading = false;
        });
      }
    };
  }

  accountVerifyCtrl.$inject = ['$state', 'LoginService', 'UtilsService', 'LRNotification'];
  angular.module('view.login').component('accountVerify', {
    bindings: {},
    controller: accountVerifyCtrl,
    templateUrl: 'views/login/components/account-verify/account-verify.html'
  });
})();